export default __webpack_public_path__ + "assets/images/g-icon4-98e3fd21.svg";